import React from 'react';

type Props = Record<string, any>;

const ScheduleScreen = (props: Props) => {
  return <div>ScheduleScreen</div>;
};

export default ScheduleScreen;
